import type { ReactNode } from 'react';
import type { IPublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import { ApplicationInsightsProvider } from '@lib/app-insights/ApplicationInsightsProvider';
import { SignalRProvider } from '@lib/signalr/SignalRClientProvider';
import { queryClient } from '@lib/queryClient';
import { ThemeProvider } from '@app/theme/ThemeProvider';
import { router } from '@app/router';

interface AppProviderProps {
  msalInstance: IPublicClientApplication;
  children: ReactNode;
}

export function AppProvider({msalInstance, children}: AppProviderProps) {
  return (
    <MsalProvider instance={msalInstance}>
      <ApplicationInsightsProvider router={router}>
        <QueryClientProvider client={queryClient}>
          <SignalRProvider>
            <ThemeProvider defaultColorScheme="auto">
              <ModalsProvider>
                <Notifications position="top-right" autoClose={8000}/>
                {children}
              </ModalsProvider>
            </ThemeProvider>
          </SignalRProvider>
        </QueryClientProvider>
      </ApplicationInsightsProvider>
    </MsalProvider>
  );
}
